import React from 'react';
import {Divider} from '@material-ui/core';
import {IApplicationDependencies} from '../../../Interfaces/interfaces';
import {FlexBox, SquaredChip, DetailWrapper, DetailItemRow, DetailItemTitle} from '../../../Shared/styles';
import {getChipColor} from '../../../Shared/utils';
import DetailTitleRow from "../DetailTitleRow/DetailTitleRow";
import {Values} from "Tools/Values";

interface IDependsOnProps {
    dependencies: IApplicationDependencies[];
}

const Dependencies = ({dependencies}: IDependsOnProps) => (
    <DetailWrapper>
        <DetailTitleRow title={Values.getLocalizationValue('dependsOn')} />

        {dependencies?.map((dependency) => (
            <div key={`${dependency.displayName}dependsOn`}>
                <DetailItemRow>
                    <DetailItemTitle>{dependency.displayName}</DetailItemTitle>

                    <FlexBox>
                        <SquaredChip
                            type={getChipColor(true)}
                            label={'active'}
                        />
                    </FlexBox>
                </DetailItemRow>
                
                <Divider/>
            </div>
        ))}
    </DetailWrapper>
);

export default Dependencies;
